import { render, staticRenderFns } from "./MediaItem.vue?vue&type=template&id=baa9f124&scoped=true"
import script from "./MediaItem.vue?vue&type=script&lang=js"
export * from "./MediaItem.vue?vue&type=script&lang=js"
import style0 from "./MediaItem.vue?vue&type=style&index=0&id=baa9f124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa9f124",
  null
  
)

export default component.exports